import {
  AllocationManualActionRequestModel,
  AllocationViewActionIdentifierModel,
  AllocationViewSelectedEntityModel,
} from '../../models';

export class AllocationViewCallToDockActionPrepare {
  public static readonly type = '[AllocationViewCallToDockAction] Call To Dock Prepare';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
    },
  ) {}
}

export class AllocationViewCallToDockAction {
  public static readonly type = '[AllocationViewCallToDockAction] Call To Dock';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
    },
  ) {}
}

export class AllocationViewCallToDockActionLoadAllocationDetails {
  public static readonly type = '[AllocationViewCallToDockAction] Load Allocation Details';

  constructor(public payload: AllocationViewSelectedEntityModel) {}
}

export class AllocationViewCallToDockActionAllocateUli {
  public static readonly type = '[AllocationViewCallToDockAction] Allocate ULI';

  constructor(public payload: AllocationManualActionRequestModel) {}
}

export class AllocationViewCallToDockActionSetInitialState {
  public static readonly type = '[AllocationViewCallToDockAction] Set Initial State';
}
